var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronClosedRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3px",
    height: "2px",
    viewBox: "0 0 3 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2BC11D0A-5EF9-448A-824B-790DF558C40C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overview-&-Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analytics-[Routines]---GMS",
    transform: "translate(-181.000000, -214.000000)",
    fill: "#70AD47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rutinas-Tabla-v3",
    transform: "translate(154.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(16.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "drop",
    transform: "translate(12.500000, 65.000000) scale(1, -1) translate(-12.500000, -65.000000) ",
    points: "12.5 64 14 66 11 66"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronClosedRight);
export default __webpack_public_path__ + "static/media/chevron-closed-right.e24f53299c953b2db27de4b1947909ba.svg";
export { ForwardRef as ReactComponent };